import React from "react";
import { ColorMap } from "../types";

interface UmapLegendProps {
  colorMap: ColorMap;
  selectedItems: string[];
  onItemClick: (itemKey: string) => void;
}

const UmapLegend: React.FC<UmapLegendProps> = ({
  colorMap,
  selectedItems,
  onItemClick,
}) => {
  if (!colorMap || Object.keys(colorMap).length === 0) return null;

  const sortedEntries = Object.entries(colorMap).sort((a, b) =>
    a[0].localeCompare(b[0])
  );

  return (
    <div className="w-full">
      <div className="grid grid-cols-2 gap-x-4 gap-y-2 max-h-[500px] overflow-y-auto">
        {sortedEntries.map(([key, color]) => {
          const isSelected = selectedItems.includes(key);

          return (
            <div
              key={key}
              className={`flex items-center p-1 rounded-md cursor-pointer transition-opacity duration-200 ${
                isSelected ? "opacity-100" : "opacity-40 hover:opacity-100"
              }`}
              onClick={() => onItemClick(key)}
            >
              <div
                className="flex-shrink-0 w-4 h-4 mr-2 rounded"
                style={{
                  backgroundColor: `rgb(${color[0]}, ${color[1]}, ${color[2]})`,
                }}
              />
              <span className="text-sm truncate" title={key}>
                {key}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UmapLegend;
